import { render, staticRenderFns } from "./MoneyCard.vue?vue&type=template&id=95d0c598&scoped=true&"
import script from "./MoneyCard.vue?vue&type=script&lang=js&"
export * from "./MoneyCard.vue?vue&type=script&lang=js&"
import style0 from "./MoneyCard.vue?vue&type=style&index=0&id=95d0c598&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d0c598",
  null
  
)

export default component.exports